// import React, { useMemo, useRef } from 'react';
// import { 
//     Box, Heading, Text, HStack, VStack, IconButton, Card, CardHeader, 
//     CardBody, Icon, Badge, Button, Tag, Tooltip
// } from '@chakra-ui/react';
// import { ArrowLeft, Printer, Download, Calendar, MapPin, User, Fuel, ShieldCheck } from 'lucide-react';
// import { AdminLayout } from '@/components/layout/AdminLayout';
// import { useParams, useNavigate, useSearchParams } from 'react-router-dom'; 
// import { DataTable, type DataTableRef, type DataTableOptions } from '@/components/tables';

// const TruckSummaryPage: React.FC = () => {
//     const navigate = useNavigate();
//     const [searchParams] = useSearchParams();
//     const tableRef = useRef<DataTableRef>(null);

//     const { plateId: paramPlateId } = useParams();
//     const plateId = useMemo(() => {
//         if (paramPlateId) return paramPlateId;
//         const pathParts = window.location.pathname.split('/');
//         return decodeURIComponent(pathParts[pathParts.length - 1]);
//     }, [paramPlateId]);

//     const urlParams = useMemo(() => {
//         const start = searchParams.get('start_date');
//         const end = searchParams.get('end_date');
//         const type = searchParams.get('filter_type');

//         return {
//             filterType: type || 'weekly',
//             startDate: start || '', 
//             endDate: end || ''
//         };
//     }, [searchParams]);

//     const dateRangeDisplay = useMemo(() => {
//         if (!urlParams.startDate || !urlParams.endDate) return 'Custom Range';
//         const start = new Date(urlParams.startDate);
//         const end = new Date(urlParams.endDate);
//         return `${start.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })} - ${end.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}`;
//     }, [urlParams.startDate, urlParams.endDate]);

//     const tableParams = useMemo(() => ({
//         filter_type: urlParams.filterType,
//         start_date: urlParams.startDate,
//         end_date: urlParams.endDate
//     }), [urlParams]);

//     const tableOptions: DataTableOptions = useMemo(() => ({
//         dataSource: `reports/transport-details/${plateId}`,
//         primaryKey: 'waybill_number',
//         dataKey: 'data',
//         pagination: true,
//         showActionsColumn: false,
//         showCheckboxes: false,
//         displayInModal: false,
//         dataFields: {
//             transaction_date: { name: 'DATE' , withSort: true },
//             waybill_number: { name: 'WAYBILL' , withSort: true },
//             shipping_line: { name: 'SHIPPING LINE', withSort: true  },
//             container_number: { name: 'CONTAINER', withSort: true  },
//             size: { name: 'SIZE', withSort: true  },
//             from: { name: 'FROM', withSort: true  },
//             to: { name: 'TO', withSort: true  },
//             driver: { name: 'DRIVER', withSort: true  },
//             helper: { name: 'HELPER', withSort: true  },
//             truck_expenses: { name: 'TRUCK EXPENSES', withSort: true  },
            
//             diesel_consumption: { name: 'DIESEL CONSUMPTION', withSort: true  },
//             status: { name: 'STATUS' },
//             encoded_by: { name: 'ENCODER', withSort: true  },
//             remarks: { name: 'REMARKS' }
//         },
//     }), [plateId]);

//     const customRenderers = useMemo(() => ({
//         waybill_number: (val: string) => (
//             <Text fontSize="xs" fontWeight="bold" color="blue.700" fontFamily="mono">{val}</Text>
//         ),
//         container_number: (val: string) => (
//             <Text color="gray.700" fontWeight="bold" fontSize="xs">{val}</Text>
//         ),
//         from: (val: string) => (
//             <HStack spacing={1}>
//                 <Icon as={MapPin} size={10} color="orange.400" />
//                 <Text fontSize="11px">{val}</Text>
//             </HStack>
//         ),
//         to: (val: string) => (
//             <HStack spacing={1}>
//                 <Icon as={MapPin} size={10} color="green.400" />
//                 <Text fontSize="11px">{val}</Text>
//             </HStack>
//         ),

//         // expenses: (val: number) => (
//         //     <Text fontWeight="bold" color="red.600" fontSize="xs">
//         //         ₱{val.toLocaleString(undefined, { minimumFractionDigits: 2 })}
//         //     </Text>
//         // ),
//         truck_expenses: (val: number) => (
//             <Text fontWeight="semibold">
//                 {new Intl.NumberFormat('en-PH', {
//                     style: 'currency', currency: 'PHP', minimumFractionDigits: 2
//                 }).format(val || 0)}
//             </Text>
//         ),
//         diesel_consumption: (val: string) => (
//             <HStack spacing={1}>
//                 <Icon as={Fuel} size={10} color="blue.400" />
//                 <Text fontSize="xs" fontWeight="medium">{val}</Text>
//             </HStack>
//         ),
//         status: (val: string) => (
//             <Badge colorScheme={val === 'Completed' ? 'green' : 'yellow'} variant="solid" fontSize="9px" borderRadius="full" px={2}>
//                 {val}
//             </Badge>
//         ),
//         encoded_by: (val: string) => (
//             <HStack spacing={1}>
//                 <Icon as={ShieldCheck} size={10} color="gray.400" />
//                 <Text fontSize="10px" color="gray.600">{val}</Text>
//             </HStack>
//         ),
//         remarks: (val: string) => (
//             <Text fontSize="xs" color="gray.600" isTruncated maxW="150px">
//                 {val || '--'}
//             </Text>
//         )
//     }), []);

//     return (
//         <AdminLayout>
//             <Box p={4} h="100%" display="flex" flexDirection="column">
//                 <VStack spacing={4} align="stretch" flex="1" overflow="hidden">
//                     <Card shadow="sm" flex="1" display="flex" flexDirection="column" overflow="hidden">
//                         <CardHeader py={3} borderBottom="1px" borderColor="gray.100">
//                             <HStack justify="space-between">
//                                 <HStack spacing={4}>
//                                     <IconButton icon={<ArrowLeft size={18} />} aria-label="Back" variant="ghost" size="sm" onClick={() => navigate(-1)} />
//                                     <Box>
//                                         <HStack spacing={2}>
//                                             <Heading size="md">{plateId}</Heading>
//                                             <Tag colorScheme="blue" variant="subtle" size="sm">{urlParams.filterType.toUpperCase()}</Tag>
//                                         </HStack>
//                                         <Text fontSize="xs" color="gray.500">Full Operational Transport Report</Text>
//                                     </Box>
//                                 </HStack>
//                                 <HStack spacing={2}>
//                                     <Button leftIcon={<Printer size={14} />} size="xs" variant="outline">Print</Button>
//                                     <Button leftIcon={<Download size={14} />} size="xs" colorScheme="blue">Export CSV</Button>
//                                 </HStack>
//                             </HStack>
//                         </CardHeader>

//                         <Box bg="gray.50" py={2} px={5} borderBottom="1px" borderColor="gray.100">
//                             <HStack spacing={2}>
//                                 <Icon as={Calendar} size={14} color="blue.500" />
//                                 <Text fontWeight="bold" fontSize="sm" color="gray.700">
//                                     Report Period: {dateRangeDisplay}
//                                 </Text>
//                             </HStack>
//                         </Box>

//                         <CardBody p={0} flex="1" overflowX="auto" overflowY="hidden" position="relative" px={5} pt={2}>
//                             <DataTable
//                                 ref={tableRef}
//                                 options={tableOptions} 
//                                 params={tableParams}
//                                 customRenderers={customRenderers}
//                                 access={{ can_view: true, can_edit: false, can_create: false, can_delete: false }}
//                             />
//                         </CardBody>
//                     </Card>
//                 </VStack>
//             </Box>
//         </AdminLayout>
//     );
// };

// export default TruckSummaryPage;

import React, { useMemo, useRef, useState } from 'react';
import { 
    Box, Heading, Text, HStack, VStack, IconButton, Card, CardHeader, 
    CardBody, Icon, Badge, Button, Tag, useColorModeValue
} from '@chakra-ui/react';
import { ArrowLeft, Calendar, MapPin, Fuel, ShieldCheck, FileDown } from 'lucide-react';
import { AdminLayout } from '@/components/layout/AdminLayout';
import { useParams, useNavigate, useSearchParams } from 'react-router-dom'; 
import { DataTable, type DataTableRef, type DataTableOptions } from '@/components/tables';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { apiClient } from '@/lib/api/client';

const TruckSummaryPage: React.FC = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const tableRef = useRef<DataTableRef>(null);
    const [isExporting, setIsExporting] = useState(false);

    const periodBg = useColorModeValue('gray.50', 'whiteAlpha.50');
    const periodBorder = useColorModeValue('gray.100', 'whiteAlpha.200');
    const periodTextColor = useColorModeValue('gray.700', 'gray.300');

    const { plateId: paramPlateId } = useParams();
    const plateId = useMemo(() => {
        if (paramPlateId) return paramPlateId;
        const pathParts = window.location.pathname.split('/');
        return decodeURIComponent(pathParts[pathParts.length - 1]);
    }, [paramPlateId]);

    const urlParams = useMemo(() => {
        const start = searchParams.get('start_date');
        const end = searchParams.get('end_date');
        const type = searchParams.get('filter_type');

        return {
            filterType: type || 'weekly',
            startDate: start || '', 
            endDate: end || ''
        };
    }, [searchParams]);

    const dateRangeDisplay = useMemo(() => {
        if (!urlParams.startDate || !urlParams.endDate) return 'Custom Range';
        const start = new Date(urlParams.startDate);
        const end = new Date(urlParams.endDate);
        return `${start.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })} - ${end.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}`;
    }, [urlParams.startDate, urlParams.endDate]);

    // const handleExportPDF = async () => {
    //     setIsExporting(true);
    //     try {
    //         const response = await apiClient.get(`reports/transport-details/${plateId}`, { 
    //             params: { ...tableParams, per_page: 500 } 
    //         });
    //         const rawData = response.data.data || [];

    //         // 'l' for landscape, 'mm', 'a4'
    //         const doc = new jsPDF('l', 'mm', 'a4');
    //         const margin = 10;

    //         const formatMoney = (val: number) => {
    //             return "P " + (val || 0).toLocaleString('en-US', {
    //                 minimumFractionDigits: 2,
    //                 maximumFractionDigits: 2
    //             });
    //         };

    //         doc.setFontSize(16);
    //         doc.text(`Transport Summary Report: ${plateId}`, margin, 12);
    //         doc.setFontSize(9);
    //         doc.text(`Period: ${dateRangeDisplay}`, margin, 18);

    //         const totalExpenses = rawData.reduce((sum: number, item: any) => sum + (Number(item.truck_expenses) || 0), 0);
    //         const totalDieselCost = rawData.reduce((sum: number, item: any) => sum + (Number(item.diesel_consumption) || 0), 0);

    //         autoTable(doc, {
    //             startY: 22,
    //             margin: { left: margin, right: margin },
    //             head: [['DATE', 'WAYBILL', 'SHIPPING', 'CONTAINER', 'SZ', 'FROM', 'TO', 'DRIVER', 'HELPER', 'TRUCK EXP', 'DIESEL P.O.', 'DIESEL', 'STATUS', 'ENCODER', 'REMARKS']],
    //             body: rawData.map((item: any) => [
    //                 item.transaction_date,
    //                 item.waybill_number,
    //                 item.shipping_line,
    //                 item.container_number,
    //                 item.size,
    //                 item.from,
    //                 item.to,
    //                 item.driver,
    //                 item.helper || '-',
    //                 formatMoney(item.truck_expenses),
    //                 item.purchase_order || '-',
    //                 formatMoney(item.diesel_consumption),
    //                 item.status,
    //                 item.encoded_by,
    //                 item.remarks || ''
    //             ]),
    //             foot: [[
    //                 '', '', '', '', '', '', '', '', 'TOTALS:', 
    //                 formatMoney(totalExpenses), 
    //                 '', 
    //                 formatMoney(totalDieselCost), 
    //                 '', '', ''
    //             ]],
    //             theme: 'striped',
    //             styles: { 
    //                 fontSize: 6.5, // Reduced font size to fit 15 columns
    //                 cellPadding: 1,
    //                 overflow: 'linebreak'
    //             },
    //             headStyles: { fillColor: [40, 40, 40], fontSize: 7 },
    //             footStyles: { fillColor: [240, 240, 240], textColor: [0, 0, 0], fontStyle: 'bold' },
    //             // Define column widths to prioritize important data
    //             columnStyles: {
    //                 0: { cellWidth: 18 }, // Date
    //                 1: { cellWidth: 22 }, // Waybill
    //                 3: { cellWidth: 25 }, // Container
    //                 9: { cellWidth: 22 }, // Expenses
    //                 11: { cellWidth: 22 }, // Diesel
    //                 14: { cellWidth: 'auto' } // Remarks takes remaining space
    //             }
    //         });

    //         doc.save(`Transport_Report_${plateId}.pdf`);
    //     } catch (error) {
    //         console.error("Export failed", error);
    //         alert("Failed to export PDF.");
    //     } finally {
    //         setIsExporting(false);
    //     }
    // };

    const handleExportPDF = async () => {
        setIsExporting(true);
        try {
            const response = await apiClient.get(`reports/transport-details/${plateId}`, { 
                params: { ...tableParams, per_page: 500 } 
            });
            const rawData = response.data.data || [];

            // 'l' for landscape, 'mm', 'a4'
            const doc = new jsPDF('l', 'mm', 'a4');
            const margin = 10;
            const pageWidth = doc.internal.pageSize.getWidth();

            const formatMoney = (val: number) => {
                return "P " + (val || 0).toLocaleString('en-US', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                });
            };

            // Calculate unique trips
            const uniqueTrips = new Set(rawData.map((item: any) => item.waybill_number)).size;

            // Header Section
            doc.setFontSize(16);
            doc.setFont("helvetica", "bold");
            doc.text(`Transport Summary Report: ${plateId}`, margin, 12);
            
            doc.setFontSize(9);
            doc.setFont("helvetica", "normal");
            doc.text(`Period: ${dateRangeDisplay}`, margin, 18);

            // Trip Counter on the right side
            doc.setFont("helvetica", "bold");
            doc.text(`Total Trips: ${uniqueTrips}`, pageWidth - margin, 18, { align: 'right' });

            const totalExpenses = rawData.reduce((sum: number, item: any) => sum + (Number(item.truck_expenses) || 0), 0);
            const totalDieselCost = rawData.reduce((sum: number, item: any) => sum + (Number(item.diesel_consumption) || 0), 0);

            autoTable(doc, {
                startY: 22,
                margin: { left: margin, right: margin },
                head: [['DATE', 'WAYBILL', 'SHIPPING', 'CONTAINER', 'SZ', 'FROM', 'TO', 'DRIVER', 'HELPER', 'TRUCK EXP', 'DIESEL P.O.', 'DIESEL', 'STATUS', 'ENCODER', 'REMARKS']],
                body: rawData.map((item: any) => [
                    item.transaction_date,
                    item.waybill_number,
                    item.shipping_line,
                    item.container_number,
                    item.size,
                    item.from,
                    item.to,
                    item.driver,
                    item.helper || '-',
                    formatMoney(item.truck_expenses),
                    item.purchase_order || '-',
                    formatMoney(item.diesel_consumption),
                    item.status,
                    item.encoded_by,
                    item.remarks || ''
                ]),
                foot: [[
                    '', '', '', '', '', '', '', '', 'TOTALS:', 
                    formatMoney(totalExpenses), 
                    '', 
                    formatMoney(totalDieselCost), 
                    '', '', ''
                ]],
                theme: 'striped',
                styles: { 
                    fontSize: 6.5, 
                    cellPadding: 1,
                    overflow: 'linebreak'
                },
                headStyles: { fillColor: [40, 40, 40], fontSize: 7 },
                footStyles: { fillColor: [240, 240, 240], textColor: [0, 0, 0], fontStyle: 'bold' },
                columnStyles: {
                    0: { cellWidth: 18 }, // Date
                    1: { cellWidth: 22 }, // Waybill
                    3: { cellWidth: 25 }, // Container
                    9: { cellWidth: 22 }, // Truck Exp
                    11: { cellWidth: 22 }, // Diesel
                    14: { cellWidth: 'auto' } // Remarks
                }
            });

            doc.save(`Transport_Report_${plateId}.pdf`);
        } catch (error) {
            console.error("Export failed", error);
            alert("Failed to export PDF.");
        } finally {
            setIsExporting(false);
        }
    };

    const tableParams = useMemo(() => ({
        filter_type: urlParams.filterType,
        start_date: urlParams.startDate,
        end_date: urlParams.endDate
    }), [urlParams]);

    const tableOptions: DataTableOptions = useMemo(() => ({
        dataSource: `reports/transport-details/${plateId}`,
        primaryKey: 'waybill_number',
        dataKey: 'data',
        pagination: true,
        showActionsColumn: false,
        showCheckboxes: false,
        displayInModal: false,
        dataFields: {
            transaction_date: { name: 'DATE' , withSort: true },
            waybill_number: { name: 'WAYBILL' , withSort: true },
            shipping_line: { name: 'SHIPPING LINE', withSort: true  },
            container_number: { name: 'CONTAINER', withSort: true  },
            size: { name: 'SIZE', withSort: true  },
            from: { name: 'FROM', withSort: true  },
            to: { name: 'TO', withSort: true  },
            driver: { name: 'DRIVER', withSort: true  },
            helper: { name: 'HELPER', withSort: true  },
            truck_expenses: { name: 'TRUCK EXPENSES', withSort: true  },
            purchase_order: { name: 'DIESEL P.O', withSort: true  },
            diesel_consumption: { name: 'DIESEL', withSort: true  },
            status: { name: 'STATUS' },
            encoded_by: { name: 'ENCODER', withSort: true  },
            remarks: { name: 'REMARKS' }
        },
    }), [plateId]);

    const customRenderers = useMemo(() => ({
        waybill_number: (val: string) => (
            <Text fontSize="xs" fontWeight="bold" color="blue.700" fontFamily="mono">{val}</Text>
        ),
        container_number: (val: string) => (
            <Text color="gray.700" fontWeight="bold" fontSize="xs">{val}</Text>
        ),
        from: (val: string) => (
            <HStack spacing={1}>
                <Icon as={MapPin} size={10} color="orange.400" />
                <Text fontSize="11px">{val}</Text>
            </HStack>
        ),
        to: (val: string) => (
            <HStack spacing={1}>
                <Icon as={MapPin} size={10} color="green.400" />
                <Text fontSize="11px">{val}</Text>
            </HStack>
        ),
        truck_expenses: (val: number) => (
            <Text fontWeight="semibold" fontSize="xs">
                {new Intl.NumberFormat('en-PH', {
                    style: 'currency', currency: 'PHP', minimumFractionDigits: 2
                }).format(val || 0)}
            </Text>
        ),
        diesel_consumption: (val: string) => (
            <HStack spacing={1}>
                <Icon as={Fuel} size={10} color="blue.400" />
                <Text fontSize="xs" fontWeight="medium">{val}</Text>
            </HStack>
        ),
        status: (val: string) => (
            <Badge colorScheme={val === 'Completed' ? 'green' : 'yellow'} variant="solid" fontSize="9px" borderRadius="full" px={2}>
                {val}
            </Badge>
        ),
        encoded_by: (val: string) => (
            <HStack spacing={1}>
                <Icon as={ShieldCheck} size={10} color="gray.400" />
                <Text fontSize="10px" color="gray.600">{val}</Text>
            </HStack>
        ),
        remarks: (val: string) => (
            <Text fontSize="xs" color="gray.600" isTruncated maxW="150px">
                {val || '--'}
            </Text>
        )
    }), []);

    return (
        <AdminLayout>
            <Box p={4} h="100%" display="flex" flexDirection="column">
                <VStack spacing={4} align="stretch" flex="1" overflow="hidden">
                    <Card shadow="sm" flex="1" display="flex" flexDirection="column" overflow="hidden">
                        <CardHeader py={3} borderBottom="1px" borderColor="gray.100">
                            <HStack justify="space-between">
                                <HStack spacing={4}>
                                    <IconButton icon={<ArrowLeft size={18} />} aria-label="Back" variant="ghost" size="sm" onClick={() => navigate(-1)} />
                                    <Box>
                                        <HStack spacing={2}>
                                            <Heading size="md">{plateId}</Heading>
                                            <Tag colorScheme="blue" variant="subtle" size="sm">{urlParams.filterType.toUpperCase()}</Tag>
                                        </HStack>
                                        <Text fontSize="xs" color="gray.500">Full Operational Transport Report</Text>
                                    </Box>
                                </HStack>
                                <HStack spacing={2}>
                                    <Button 
                                        leftIcon={<FileDown size={18} />} 
                                        colorScheme="blue" 
                                        size="sm"
                                        px={4}
                                        fontWeight="semibold"
                                        onClick={handleExportPDF}
                                        isLoading={isExporting}
                                        loadingText="Generating..."
                                    >
                                        Export PDF
                                    </Button>
                                </HStack>
                            </HStack>
                        </CardHeader>

                        {/* <Box bg="gray.50" py={2} px={5} borderBottom="1px" borderColor="gray.100">
                            <HStack spacing={2}>
                                <Icon as={Calendar} size={14} color="blue.500" />
                                <Text fontWeight="bold" fontSize="sm" color="gray.700">
                                    Report Period: {dateRangeDisplay}
                                </Text>
                            </HStack>
                        </Box> */}
                        <Box 
                            bg={periodBg} 
                            py={2} 
                            px={5} 
                            borderBottom="1px" 
                            borderColor={periodBorder}
                        >
                            <HStack spacing={2}>
                                <Icon as={Calendar} size={14} color="blue.500" />
                                <Text fontWeight="bold" fontSize="sm" color={periodTextColor}>
                                    Report Period: {dateRangeDisplay}
                                </Text>
                            </HStack>
                        </Box>

                        <CardBody p={0} flex="1" overflowX="auto" overflowY="hidden" position="relative" px={5} pt={2}>
                            <DataTable
                                ref={tableRef}
                                options={tableOptions} 
                                params={tableParams}
                                customRenderers={customRenderers}
                                access={{ can_view: true, can_edit: false, can_create: false, can_delete: false }}
                            />
                        </CardBody>
                    </Card>
                </VStack>
            </Box>
        </AdminLayout>
    );
};

export default TruckSummaryPage;